import { Route, Routes } from 'react-router-dom';
import Userlayout from '../layout/Userlayout';
import AccountDashboard from '../pages/AccountDashboard';
import NotFoundPage from '../pages/NotFoundPage';
import CustomersPage from '../pages/customer-page/CustomersPage';
import { PrivateRoute } from './PrivateRoutes';
import AddCustomerPage from '../pages/AddCustomerPage';

import ChartOfAccountPage from '../pages/chart_of_account/ChartOfAccountPage';
import AddNewChartOfAccountPage from '../pages/chart_of_account/AddNewChartOfAccountPage';
import ChartOfAccountDetailsPage from '../pages/chart_of_account/ChartOfAccountDetailsPage';
import InvoicePage from '../pages/invoice_page/InvoicePage';
import AddInvoicePage from '../pages/invoice_page/AddInvoicePage';
import CustomerDetailsPage from '../pages/customer-page/CustomerDetailsPage';
import CompositeItemGroupPage from '../pages/CompositeItemGroupPage';
import CompositeItemGroupAddNew from '../pages/item-page/AddItemFormProps/CompositeitemGroupAddNew';
import CompositeGroupDetailsPage from '../pages/CompositeGroupDetailsPage';
import ItemGroupPage from '../pages/item_group/ItemGroupPage';
import AddItemGroup from '../pages/item_group/AddItemGroup';
import ItemDetailsPage from '../pages/item-page/ItemDetailsPage';
import ItemPage from '../pages/item-page/ItemPage';
import AddItemPage from '../pages/item-page/AddItemPage';

import PurchaseOrderDetailsPage from '../pages/purchase_order/PurchaseOrderDetailsPage';
import VendorPage from '../pages/vendor/VendorPage';
import AddVendorPage from '../pages/vendor/AddVendorPage';
import VendorDetailsPage from '../pages/vendor/VendorDetailsPage';
import BillsDetailsPage from '../pages/bill/BillsDetailsPage';
import BillPage from '../pages/bill/BillPage';
import AddBillPage from '../pages/bill/AddBillPage';
import PurchaseReceivePage from '../pages/purchase_receive/PurchaseReceivePage';
import AddPurchaseReceivePage from '../pages/AddPurchaseReceivePage';
import SalesOrderPage from '../pages/sales_order/SalesOrderPage';
import AddSalesOrderPage from '../pages/sales_order/AddSalesOrderPage';
import SalesOrderDetailsPage from '../pages/sales_order/SalesOrderDetailsPage';
import InvoiceDetailsPage from '../pages/invoice_page/InvoiceDetailsPage';
import PaymentReceivedPage from '../pages/payment_receive/PaymentReceivedPage';
import PaymentReceivedDetailsPage from '../pages/payment_receive/PaymentReceivedDetailsPage';
import PurchaseOrderPage from '../pages/purchase_order/PurchaseOrderPage';
import AddPurchaseOrderPage from '../pages/purchase_order/AddPurchaseOrderPage';
import PurchaseReceiveDetailsPage from '../pages/purchase_receive/PurchaseReceiveDetailsPage';
import PaymentGateWayPage from '../pages/payment_gateway/PaymentGatewayPage';
import WalletCheckPage from '../pages/WalletVariance/WalletCheckPage';
import WalletCheckDetails from '../pages/WalletVariance/WalletCheckDetails';
import VoucherCorporateMainPage from '../pages/vouchers-corporate/VoucherCorporateMainPage';
import VoucherCorDetailsPage from '../pages/vouchers-corporate/VoucherCorDetailsPage';
import AddCorporateVoucherPage from '../pages/vouchers-corporate/AddCorporateVoucherPage';
import VoucherOfflinePage from '../pages/voucher-offline/VoucherOfflinePage';
import OfflineDetailsPage from '../pages/voucher-offline/OfflneDetailsPage';
import OfflineVoucherRedeem from '../pages/voucher-offline/OfflineVoucherRedeem';
import PriceListPage from '../pages/price_list/PriceListPage';
import PriceListDetailsPage from '../pages/price_list/PriceListDetailsPage';
import CorporatePage from '../pages/corprate_page/CorporatePage';
import AddCorporatePage from '../pages/corprate_page/AddCorporatePage';
import CorporateDetailsPage from '../pages/corprate_page/CorporateDetailsPage';
import CustomerApprovalPage from '../pages/customer_approval/customerApprovalPage';
import CustomerApproveDetails from '../pages/customer_approval/customerApprovedetails';
import CorporateApprovalPage from '../pages/corporate_approval/CorporateApprovalPage';
import CorporateAppDetailsPage from '../pages/corporate_approval/CorperateAppDetailsPage';
import RatingMainPage from '../pages/rating/RatingMainPage';
import RatingDetailsPage from '../pages/rating/RatingDetailsPage';
import RewardCenterSetup from '../pages/reward_center/setup/RewardCenterSetup';
import RewardEarnPage from '../pages/reward_history/RewardEarnPage';
import RewardHistoryDetails from '../pages/reward_history/RewardHistorydetails';
import RewardRedeemPage from '../pages/reward_redeeem/RewardRedeemPage';
import CarrierBagAddNewPage from '../pages/carreer_bag/CarrierBadAddNewPage';
import CarrierDetailsPage from '../pages/carreer_bag/CarrierPageDetails';
import CreditNoteMainPage from '../pages/credit_note/CreditNoteMainPage';
import CreditNoteDetailsPage from '../pages/credit_note/CreditNoteDetailsPage';
import CreditNoteAddNew from '../pages/credit_note/CreditNoteAddNew';
import VoucherDetailsPage from '../pages/vouchers/VoucherDetailPage';
import VouchersMainPage from '../pages/vouchers/VoucherMainPage';
import ManualJournalMainPage from '../pages/manual_journals/ManualJournalMainPage';
import ManualJournalDetailsPage from '../pages/manual_journals/ManualJournalDetailsPage';
import NewManualJournalPage from '../pages/manual_journals/NewManualJournal';
import ItemGroupDetailsPage from '../pages/item_group/ItemGroupDetailsPage';
import ChartOfAccountOpeningPage from '../pages/chart_of_account/ChartOfAccountOpenPage';
import ProductFeaturePage from '../pages/product_feature/ProductFeaturePage';
import AddProductFeature from '../pages/product_feature/AddProductFeature';
import ProductFeatureDetail from '../pages/product_feature/ProductFeatureDetail';
import ExpenseMainPage from '../pages/expense/ExpenseMainPage';
import AddExpensePage from '../pages/expense/AddExpensePage';
import ExpenseDetailsPage from '../pages/expense/ExpenseDetailsPage';
import PackageDetailsPage from '../pages/packages/PackageDetailsPage';
import PackageNewShipping from '../pages/packages/PackageNewShipping';
import PackagesMainPage from '../pages/packages/PackagesMainPage';
import PackageAddNew from '../pages/packages/PackageAddNew';
import MappingAccountPage from '../pages/mapping-account/MappingAccountPage';
import AccountClassSetupPage from '../pages/account-class-setup/AccountClassSetupPage';
import BankChargeMainPage from '../pages/bank-charge/BankChargeMainPage';
import ProductSharingPage from '../pages/product-sharing/ProductSharingPage';
import ProductSharingDetailsPage from '../pages/product-sharing/ProductSharingDetailsPage';
import ProductPage from '../pages/product/ProductPage';
import AddProductPlanPage from '../pages/product/AddProductPlanPage';
import AddAddOnPage from '../pages/product/AddAddOnPage';
import AddCouponPage from '../pages/product/AddCouponPage';
import AddPaymentReceivePage from '../pages/payment_receive/AddPaymentReceivePage';
import WalletTransMainPage from '../pages/walletTrans/WalletTransMainPage';
import WalletTransDetailsPage from '../pages/walletTrans/WalletTransDetailsPage';
import CustomerDebitNoteMainPage from '../pages/customer-debit-notes/CustomerDebitNoteMainPage';
import DebitNoteDetailsPage from '../pages/customer-debit-notes/DebitNoteDetailsPage';
import DebitNoteAddNew from '../pages/customer-debit-notes/DebitNoteAddNew';
import SalesOrderReturnMinPage from '../pages/sales-order-return/SaleOrderReturnMainPage';
import SalesOrderReturnDetailsPage from '../pages/sales-order-return/SalesOrderReturnDetailsPage';
import BankingMainPage from '../pages/banking/BankingMainPage';
import BankingDetailPage from '../pages/banking/BankingDetailPage';
import AddBankingPage from '../pages/banking/AddBankingPage';
import PaymentMadeDetailsPage from '../pages/payment-made/PaymentMadeDetailsPage';
import PaymentMadeAddNewPage from '../pages/payment-made/PaymentMadeAddNewPage';
import PaymentMadeMainPage from '../pages/payment-made/PaymentMadeMainPage';
import FundTransferMainPage from '../pages/funds-transfer/FundTransferMainPage';
import FundTransferDetailsPage from '../pages/funds-transfer/FundTransferDetailsPage';
import AddFundTransferPage from '../pages/funds-transfer/AddFundTransferPage';
import BudgetMainPage from '../pages/budget/BudgetMainPage';
import BudgetDetailsPage from '../pages/budget/BudgetDetailsPage';
import AddBudgetPagePage from '../pages/budget/AddBudgetPagePage';

function AccountRoutes() {
  return (
    <>
      <Userlayout>
        <Routes>
          <Route
            path="customers"
            element={
              <PrivateRoute>
                {' '}
                <CustomersPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/customers/customer-details/:customer_id"
            element={
              <PrivateRoute>
                {' '}
                <CustomerDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/customers/add_customer"
            element={
              <PrivateRoute>
                {' '}
                <AddCustomerPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                {' '}
                <AccountDashboard />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/dashboard/customer-details/:customer_id"
            element={
              <PrivateRoute>
                {' '}
                <CustomerDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ======= CHART OF ACCOUNT ======== */}
          <Route
            exact
            path="/chart-of-accounts-opening"
            element={
              <PrivateRoute>
                {' '}
                <ChartOfAccountOpeningPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ======= CHART OF ACCOUNT ======== */}
          <Route
            exact
            path="/bank-charge"
            element={
              <PrivateRoute>
                {' '}
                <BankChargeMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/chart-of-accounts"
            element={
              <PrivateRoute>
                {' '}
                <ChartOfAccountPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/chart-of-accounts/add-new"
            element={
              <PrivateRoute>
                <AddNewChartOfAccountPage />
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/chart-of-accounts/details/:chart_id"
            element={
              <PrivateRoute>
                {' '}
                <ChartOfAccountDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          {/* ======= CHART OF ACCOUNT END ======== */}

          {/* ===== WALLET TRANSACTION ======== */}
          <Route
            exact
            path="/wallet-transactions"
            element={
              <PrivateRoute>
                {' '}
                <WalletTransMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/wallet-transactions/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <WalletTransDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ===== WALLET TRANSACTION END ======== */}

          {/* Packages */}
          <Route
            path="/package-setup"
            element={
              <PrivateRoute>
                {' '}
                <PackagesMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/package-setup/add-new"
            element={
              <PrivateRoute>
                {' '}
                <PackageAddNew />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/package-setup/add-new-shipping"
            element={
              <PrivateRoute>
                {' '}
                <PackageNewShipping />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/package-setup/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <PackageDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* Mapping Transaction Page */}
          <Route
            path="/mapping-accounts-transaction"
            element={
              <PrivateRoute>
                {' '}
                <MappingAccountPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/product-sharing"
            element={
              <PrivateRoute>
                {' '}
                <ProductSharingPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/product-sharing/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <ProductSharingDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* Mapping Transaction Page */}
          <Route
            path="/account-class-setup"
            element={
              <PrivateRoute>
                {' '}
                <AccountClassSetupPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ======= EXPENSE  */}

          {/* Product feature */}
          <Route
            path="/expenses"
            element={
              <PrivateRoute>
                {' '}
                <ExpenseMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/expenses/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddExpensePage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/expenses/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <ExpenseDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ======= EXPENSE END */}

          {/* PRODUCT ROUTES  */}
          <Route
            exact
            path="/products"
            element={
              <PrivateRoute>
                {' '}
                <ProductPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/add-plan/:product_id"
            element={
              <PrivateRoute>
                {' '}
                <AddProductPlanPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/add-addon/:product_id"
            element={
              <PrivateRoute>
                {' '}
                <AddAddOnPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/edit-addon/:addon_id_edit/:product_id_edit"
            element={
              <PrivateRoute>
                {' '}
                <AddAddOnPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/add-coupon/:product_id"
            element={
              <PrivateRoute>
                {' '}
                <AddCouponPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          {/* ==== PRODUCT END ===== */}

          {/* Product feature */}
          <Route
            path="/product-category-feature"
            element={
              <PrivateRoute>
                {' '}
                <ProductFeaturePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/product-category-feature/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddProductFeature />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/product-category-feature/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <ProductFeatureDetail />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/invoices"
            element={
              <PrivateRoute>
                {' '}
                <InvoicePage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/invoices/add-invoice"
            element={
              <PrivateRoute>
                {' '}
                <AddInvoicePage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/invoices/details/:invoice_id"
            element={
              <PrivateRoute>
                {' '}
                <InvoiceDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/customer-approval"
            element={
              <PrivateRoute>
                {' '}
                <CustomerApprovalPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/customer-approval/details/:customer_id"
            element={
              <PrivateRoute>
                {' '}
                <CustomerApproveDetails />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/carrier-bag-return"
            element={
              <PrivateRoute>
                {' '}
                <CarrierBagAddNewPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/carrier-bag-return/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <CarrierDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/carrier-bag-return/add-new"
            element={
              <PrivateRoute>
                {' '}
                <CarrierBagAddNewPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate"
            element={
              <PrivateRoute>
                {' '}
                <CorporatePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/corporate/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddCorporatePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/corporate/details/:corporate_id"
            element={
              <PrivateRoute>
                {' '}
                <CorporateDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate-approval"
            element={
              <PrivateRoute>
                {' '}
                <CorporateApprovalPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate-approval/details/:corporate_id"
            element={
              <PrivateRoute>
                {' '}
                <CorporateAppDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/Setup"
            element={
              <PrivateRoute>
                {' '}
                <RewardCenterSetup />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/reward"
            element={
              <PrivateRoute>
                {' '}
                <RewardEarnPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/reward/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <RewardHistoryDetails />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* Reward redeem */}
          <Route
            path="/reward-redeem"
            element={
              <PrivateRoute>
                {' '}
                <RewardRedeemPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/grocedy-rating"
            element={
              <PrivateRoute>
                {' '}
                <RatingMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/grocedy-rating/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <RatingDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/payment-received"
            element={
              <PrivateRoute>
                {' '}
                <PaymentReceivedPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/payment-received/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddPaymentReceivePage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/payment-received/details/:payment_ref_id"
            element={
              <PrivateRoute>
                {' '}
                <PaymentReceivedDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/composite-item-group"
            element={
              <PrivateRoute>
                {' '}
                <CompositeItemGroupPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/composite-item-group/add-new"
            element={
              <PrivateRoute>
                {' '}
                <CompositeItemGroupAddNew />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/composite-item-group/details/:group_id"
            element={
              <PrivateRoute>
                {' '}
                <CompositeGroupDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/item-groups"
            element={
              <PrivateRoute>
                {' '}
                <ItemGroupPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/item-groups/add-item-group"
            element={
              <PrivateRoute>
                <AddItemGroup />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/item-groups/item-group-details/:item_group_id"
            element={
              <PrivateRoute>
                {' '}
                <ItemGroupDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/items"
            element={
              <PrivateRoute>
                {' '}
                <ItemPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/items/add-item/:option"
            element={
              <PrivateRoute>
                {' '}
                <AddItemPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/items/item-details/:item_id"
            element={
              <PrivateRoute>
                {' '}
                <ItemDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/purchase-order"
            element={
              <PrivateRoute>
                {' '}
                <PurchaseOrderPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/purchase-order/details/:purchase_id"
            element={
              <PrivateRoute>
                {' '}
                <PurchaseOrderDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/purchase-order/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddPurchaseOrderPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/vendors"
            element={
              <PrivateRoute>
                {' '}
                <VendorPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/vendors/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddVendorPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/vendors/details/:vendor_id"
            element={
              <PrivateRoute>
                {' '}
                <VendorDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/bills"
            element={
              <PrivateRoute>
                {' '}
                <BillPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/bills/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddBillPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/bills/details/:bill_id"
            element={
              <PrivateRoute>
                {' '}
                <BillsDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/purchase-receives"
            element={
              <PrivateRoute>
                {' '}
                <PurchaseReceivePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/purchase-receives/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddPurchaseReceivePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/purchase-receives/details/:purchase_id"
            element={
              <PrivateRoute>
                {' '}
                <PurchaseReceiveDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/sales-order"
            element={
              <PrivateRoute>
                {' '}
                <SalesOrderPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/sales-order/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddSalesOrderPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/sales-order/details/:sales_id"
            element={
              <PrivateRoute>
                {' '}
                <SalesOrderDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ================ SALES ORDER RETURN ROUTES */}
          <Route
            path="/sales-order-return"
            element={
              <PrivateRoute>
                {' '}
                <SalesOrderReturnMinPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/sales-order-return/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <SalesOrderReturnDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ================ SALES ORDER RETURN ROUTES END */}

          <Route
            path="/payment-gateway"
            element={
              <PrivateRoute>
                {' '}
                <PaymentGateWayPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          {/* <Route  path='/sales-order/add-new' element={
                  <PrivateRoute>  <AddSalesOrderPage /> </PrivateRoute>}>
            </Route>
            <Route  path='/sales-order/details/:sales_id' element={
                  <PrivateRoute>  <SalesOrderDetailsPage /> </PrivateRoute>}>
            </Route> */}

          {/* Wallet Variant */}
          <Route
            path="/wallet-check"
            element={
              <PrivateRoute>
                {' '}
                <WalletCheckPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/wallet-check/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <WalletCheckDetails />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/corporate-voucher"
            element={
              <PrivateRoute>
                {' '}
                <VoucherCorporateMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/corporate-voucher/add-new"
            element={
              <PrivateRoute>
                {' '}
                <AddCorporateVoucherPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/corporate-voucher/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <VoucherCorDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/redeem-offline-voucher"
            element={
              <PrivateRoute>
                {' '}
                <VoucherOfflinePage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/redeem-offline-voucher/add-new"
            element={
              <PrivateRoute>
                {' '}
                <OfflineVoucherRedeem />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/redeem-offline-voucher/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <OfflineDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/price-list"
            element={
              <PrivateRoute>
                {' '}
                <PriceListPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/price-list/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <PriceListDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* Voucher */}
          <Route
            path="/voucher"
            element={
              <PrivateRoute>
                {' '}
                <VouchersMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/voucher/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <VoucherDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ============ CREDIT NOTE */}
          <Route
            path="/credit-notes"
            element={
              <PrivateRoute>
                {' '}
                <CreditNoteMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/credit-notes/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <CreditNoteDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/credit-notes/add-new"
            element={
              <PrivateRoute>
                {' '}
                <CreditNoteAddNew />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ==== CREDIT NOTE END ============= */}


          {/* ================ PAYMENT MADE START ============ */}
          <Route
            path="/payment-mades"
            element={
              <PrivateRoute> <PaymentMadeMainPage /> </PrivateRoute>
            }
          ></Route>

          <Route
            path="//payment-mades/add-new"
            element={
              <PrivateRoute> <PaymentMadeAddNewPage /> </PrivateRoute>
            }
          ></Route>


          <Route
            path="//payment-mades/details/:id"
            element={
              <PrivateRoute> <PaymentMadeDetailsPage /> </PrivateRoute>
            }
          ></Route>


          {/* ================ PAYMENT MADE END ============ */}


          {/* ============= CUSTOMER DEBIT NOTE ============== */}
          <Route
            path="/customer-debit-notes"
            element={
              <PrivateRoute>
                <CustomerDebitNoteMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/customer-debit-notes/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <DebitNoteDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/customer-debit-notes/add-new"
            element={
              <PrivateRoute>
                {' '}
                <DebitNoteAddNew />{' '}
              </PrivateRoute>
            }
          ></Route>

          {/* ============= CUSTOMER DEBIT NOTE END  ============== */}

          <Route
            path="/manual-journals"
            element={
              <PrivateRoute>
                {' '}
                <ManualJournalMainPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/manual-journals/details/:id"
            element={
              <PrivateRoute>
                {' '}
                <ManualJournalDetailsPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/manual-journals/add-new"
            element={
              <PrivateRoute>
                {' '}
                <NewManualJournalPage />{' '}
              </PrivateRoute>
            }
          ></Route>

          <Route path="/*" element={<NotFoundPage />}></Route>


          {/* ================  BANKING ROUTES ============= */}
          <Route
            path="/banking"
            element={
              <PrivateRoute> <BankingMainPage /> </PrivateRoute>
            }
          ></Route>
          <Route
            path="/banking/add-new"
            element={
              <PrivateRoute> <AddBankingPage /> </PrivateRoute>
            }
          ></Route>

          <Route
            path="/banking/details/:id"
            element={
              <PrivateRoute> <BankingDetailPage /> </PrivateRoute>
            }
          ></Route>

          {/* ================ BANKING ROUTES END ============ */}


          {/* ================ FUND TRANSFER ROUTES  ============ */}
          <Route
            path="/account-fund-transfer"
            element={
              <PrivateRoute> <FundTransferMainPage /> </PrivateRoute>
            }
          ></Route>
          <Route
            path="/account-fund-transfer/add-new"
            element={
              <PrivateRoute> <AddFundTransferPage /> </PrivateRoute>
            }
          ></Route>
          <Route
            path="/account-fund-transfer/details/:id"
            element={
              <PrivateRoute> <FundTransferDetailsPage /> </PrivateRoute>
            }
          ></Route>
          {/* ================ FUND TRANSFER ROUTES END ============ */}

          {/* ==================== BUDGET ROUTES ==================== */}

          <Route
            path="/account-budget"
            element={
              <PrivateRoute> <BudgetMainPage /> </PrivateRoute>
            }
          ></Route>

          <Route
            path="/account-budget/details/:id"
            element={
              <PrivateRoute> <BudgetDetailsPage /> </PrivateRoute>
            }
          ></Route>

          <Route
            path="/account-budget/add-new"
            element={
              <PrivateRoute> <AddBudgetPagePage /> </PrivateRoute>
            }
          ></Route>

          {/* ==================== BUDGET ROUTES END ==================== */}

        </Routes>



      </Userlayout>
    </>
  );
}

export default AccountRoutes;
